import { render, staticRenderFns } from "./TaskMsgDialog.vue?vue&type=template&id=537bfea4&"
import script from "./TaskMsgDialog.vue?vue&type=script&lang=js&"
export * from "./TaskMsgDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports